/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminMarketReferenceSource,
    AdminMarketReferenceSourceFromJSON,
    AdminMarketReferenceSourceFromJSONTyped,
    AdminMarketReferenceSourceToJSON,
} from './AdminMarketReferenceSource';
import {
    AdminMarketplaceType,
    AdminMarketplaceTypeFromJSON,
    AdminMarketplaceTypeFromJSONTyped,
    AdminMarketplaceTypeToJSON,
} from './AdminMarketplaceType';

/**
 * 
 * @export
 * @interface AdminMarketPoint
 */
export interface AdminMarketPoint {
    /**
     * 
     * @type {string}
     * @memberof AdminMarketPoint
     */
    capturedAt: string;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketPoint
     */
    comparablesCount: number;
    /**
     * ListingID is set for a manual price entered for one listing.
     * @type {number}
     * @memberof AdminMarketPoint
     */
    listingId?: number;
    /**
     * 
     * @type {AdminMarketplaceType}
     * @memberof AdminMarketPoint
     */
    marketplace: AdminMarketplaceType;
    /**
     * 
     * @type {number}
     * @memberof AdminMarketPoint
     */
    median: number;
    /**
     * 
     * @type {AdminMarketReferenceSource}
     * @memberof AdminMarketPoint
     */
    source: AdminMarketReferenceSource;
}



export function AdminMarketPointFromJSON(json: any): AdminMarketPoint {
    return AdminMarketPointFromJSONTyped(json, false);
}

export function AdminMarketPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminMarketPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'capturedAt': json['capturedAt'],
        'comparablesCount': json['comparablesCount'],
        'listingId': !exists(json, 'listingId') ? undefined : json['listingId'],
        'marketplace': AdminMarketplaceTypeFromJSON(json['marketplace']),
        'median': json['median'],
        'source': AdminMarketReferenceSourceFromJSON(json['source']),
    };
}

export function AdminMarketPointToJSON(value?: AdminMarketPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'capturedAt': value.capturedAt,
        'comparablesCount': value.comparablesCount,
        'listingId': value.listingId,
        'marketplace': AdminMarketplaceTypeToJSON(value.marketplace),
        'median': value.median,
        'source': AdminMarketReferenceSourceToJSON(value.source),
    };
}

